import { FetchedOffer } from "../offers/actions";
import OfferModel from "../offers/offerModel";

class OrderSummaryModel {
  offers: Array<FetchedOffer>;

  constructor(offers: Array<FetchedOffer>) {
    this.offers = offers;
  }

  computeTotalPrice() {
    const sum = this.offers.reduce((sum: number, offer) => {
      return offer.priceInCents + sum;
    }, 0);

    return (sum / 100).toFixed(2);
  }

  computeMSRP() {
    const sum = this.offers
      .filter((o) => {
        return o.name.toLowerCase().includes("shipping") === false;
      })
      .reduce((sum: number, offer) => {
        return (offer.msrpInCents || offer.priceInCents) + sum;
      }, 0);

    return (sum / 100).toFixed(2);
  }

  computeShippingCost() {
    const sum = this.offers.reduce((sum: number, offer) => {
      if (offer.name.toLowerCase().includes("shipping")) {
        return offer.priceInCents + sum;
      }
      return sum;
    }, 0);

    const cost = (sum / 100).toFixed(2);
    if (cost === "0.00") {
      return "FREE";
    }
    return cost;
  }

  numberOfPayments() {
    return Math.max(
      ...this.offers.map((offer) => {
        return offer.numberOfInstallmentsAllowed || 1;
      })
    );
  }

  amountOfAdditionalMonthlyPayments() {
    const totalPrice = Number(this.computeTotalPrice());
    const amountDueToday = Number(this.computeAmountDueToday());

    return (
      (totalPrice - amountDueToday) /
      (this.numberOfPayments() - 1)
    ).toFixed(2);
  }

  computeAmountDueToday() {
    const sum = this.offers.reduce((sum: number, offer) => {
      if (
        offer.monthsBeforeCharge == 0 &&
        offer.numberOfInstallmentsAllowed > 1
      ) {
        return sum + offer.priceInCents / offer.numberOfInstallmentsAllowed;
      } else if (offer.monthsBeforeCharge == 0) {
        return sum + offer.priceInCents;
      }

      return sum;
    }, 0);

    return (sum / 100).toFixed(2);
  }

  totalSavings() {
    return this.offers
      .map((offer) => new OfferModel(offer))
      .reduce((sum, offerModel) => {
        const savings = Number(offerModel.calculateSavings());
        return savings ? savings + sum : sum; // If savings is not null or 0, add it to sum, otherwise, just return sum.
      }, 0)
      .toFixed(2);
  }
}

export default OrderSummaryModel;
